export default {"src":"/_next/static/media/better-stack.3082111a.svg","height":21,"width":154,"blurWidth":0,"blurHeight":0};